import { ActionFunction, redirect } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GQL
import { formOrderNaming } from '../../../../../components/forms/NewWorkOrderForm/constants';

// Actions
import { passData } from './ActionUtils/passData';
import { saveData } from './ActionUtils/saveData';
import { showSuccessToast } from '../../../../../utils/toasts';
import i18n from '../../../../../i18n';

/**
 * OfflineQueueLink lanza un Error con `offlineQueued: true` cuando la mutation
 * se encola sin red. Apollo lo envuelve en ApolloError, así que comprobamos
 * tanto el flag como el mensaje y la propiedad en networkError.
 */
function isOfflineQueuedError(err: unknown): boolean {
  const e = err as {
    offlineQueued?: boolean;
    message?: string;
    networkError?: { offlineQueued?: boolean };
  };
  return (
    e?.offlineQueued === true ||
    e?.networkError?.offlineQueued === true ||
    (e?.message ?? '').includes('Mutation queued for offline sync')
  );
}

export const ActionNewWorkOrderSummary: ActionFunction = async ({
  request,
}) => {
  const formData = await request.formData();
  const intent = formData.get('intent');
  if (intent === 'pass-data') {
    try {
      return passData(formData);
    } catch (err) {
      Sentry.captureException(err);
      console.log('Error:', err);
    }
  }
  if (intent === 'save-data') {
    try {
      const dataFormRaw = sessionStorage.getItem(
        formOrderNaming.NEW_WORK_ORDER_FORM
      );
      return await saveData(dataFormRaw);
    } catch (err) {
      // Bloque C-7.5: si la mutation se encoló offline, OfflineQueueLink lanza
      // un Error que llegaba al ErrorBoundary del router. Lo tratamos como
      // éxito: limpiamos sessionStorage y redirigimos a la lista. Al
      // reconectar, syncOfflineQueue replay-ea la SaveGenericOrder.
      if (isOfflineQueuedError(err)) {
        showSuccessToast(i18n.t('modals:changeState.queuedOffline'));
        sessionStorage.removeItem(formOrderNaming.NEW_WORK_ORDER_FORM);
        window.dispatchEvent(new CustomEvent('offline-workorder-queued'));
        return redirect('/work-orders');
      }
      Sentry.captureException(err);
      console.log('> NewOrderSummary - error creating:', err);
    }
  }
  return null;
};
